import { MutationTree } from "vuex";
import { IUiState } from "./types";

export namespace UI_MUTATIONS {
  export const TOGGLE_IS_LOADING = "toggleIsLoading";
  export const ADD_TOAST = "addToast";
  export const REMOVE_TOAST_BY_ID = "removeToastById";
}

export const mutations: MutationTree<IUiState> = {
  [UI_MUTATIONS.TOGGLE_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [UI_MUTATIONS.ADD_TOAST](state, { id, text, type }) {
    state.toasts = [...state.toasts, { id, text, type }];
  },
  [UI_MUTATIONS.REMOVE_TOAST_BY_ID](state, idToRemove) {
    state.toasts = state.toasts.filter(toast => {
      return idToRemove !== toast.id;
    });
  }
};
